/**
 * Browser extensions (VPN, ad blockers, password managers, etc.) inject scripts
 * into every page. When they throw, React's dev overlay can cover the whole app
 * even though our code is fine.
 *
 * Example seen in the field:
 *   Cannot read properties of undefined (reading 'M_ID')
 *   at chrome-extension://eppiocemhmnlbhjplcgkofciiegomcon/...
 *   (Urban VPN Proxy extension)
 */
const EXTENSION_URL_RE =
  /^(chrome|moz|safari|ms-browser)-extension:\/\//i;

function mentionsExtensionSource(value) {
  if (!value) return false;
  const text =
    typeof value === "string"
      ? value
      : value?.stack || value?.message || String(value);
  return /-extension:\/\//i.test(text);
}

function isExtensionScriptError(event) {
  const filename = event?.filename || "";
  if (EXTENSION_URL_RE.test(filename)) return true;
  if (mentionsExtensionSource(event?.error)) return true;
  if (mentionsExtensionSource(event?.message)) return true;
  return false;
}

function isExtensionRejection(event) {
  return mentionsExtensionSource(event?.reason);
}

function setupThirdPartyScriptErrorGuards() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "error",
    (event) => {
      if (!isExtensionScriptError(event)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (!isExtensionRejection(event)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}

setupThirdPartyScriptErrorGuards();
